const BACKEND_BASE_URL = process.env.REACT_APP_BASE_URL;

const IMAGE_HOST = (
  process.env.REACT_APP_IMAGE_BASE_URL || BACKEND_BASE_URL || ""
).replace(/\/$/, "");

// Image CDN / static files
export const IMAGE_BASE_URL = `${IMAGE_HOST}/`;

export function resolveImageUrl(url) {
  if (!url) return url;
  const value = String(url).trim();
  if (!value) return value;

  const normalized = value.replace(/\/manuf\//i, "/manufacturers/");

  if (!/^https?:\/\//i.test(normalized)) {
    return `${IMAGE_BASE_URL}${normalized.replace(/^[\\/]+/, "")}`;
  }

  try {
    const parsed = new URL(normalized);
    const isLocalHost =
      parsed.hostname === "localhost" ||
      parsed.hostname === "127.0.0.1" ||
      /^\d+\.\d+\.\d+\.\d+$/.test(parsed.hostname);
    if (isLocalHost) {
      return `${IMAGE_HOST}${parsed.pathname}${parsed.search}`;
    }
  } catch (_) {
    return normalized;
  }

  return normalized;
}

// User Routes
export const LOGIN = `${BACKEND_BASE_URL}/api/admin/login`;

// Vehicle Routes
export const ADD_VEHICLE = `${BACKEND_BASE_URL}/api/vehicles/add_vehicle`;
export const ALL_VEHICLE = `${BACKEND_BASE_URL}/api/vehicles/all_vehicle`;
export const GET_SINGLE_VEHICLE = `${BACKEND_BASE_URL}/api/vehicles/get_single_vehicle`;
export const UPDATE_VEHICLE = `${BACKEND_BASE_URL}/api/vehicles/update_vehicle`;
export const DUPLICATE_VEHICLE = `${BACKEND_BASE_URL}/api/vehicles/duplicate_vehicle`;
export const SET_VEHICLE_STATUS = `${BACKEND_BASE_URL}/api/vehicles/set_vehicle_status`;
export const DELETE_VEHICLE = `${BACKEND_BASE_URL}/api/vehicles/delete_vehicle`;

// Manufacturer Routes
export const ADD_MANUFACTURER = `${BACKEND_BASE_URL}/api/manufacturer/add_manufacturer`;
export const ALL_MANUFACTURER = `${BACKEND_BASE_URL}/api/manufacturer/all_manufacturers`;
export const UPDATE_MANUFACTURER = `${BACKEND_BASE_URL}/api/manufacturer/update_manufacturer`;

// Subscriptions
export const ADD_SUBSCRIPTION = `${BACKEND_BASE_URL}/api/subscription/add_subscription`;
export const UPDATE_SUBSCRIPTION = `${BACKEND_BASE_URL}/api/subscription/update_subscription`;
export const SET_SUBSCRIPTION_VISIBILITY = `${BACKEND_BASE_URL}/api/subscription/set_subscription_visibility`;
export const ALL_SUBSCRIPTION = `${BACKEND_BASE_URL}/api/subscription/subscription-list?includeHidden=true`;
export const USER_SUBSCRIPTION_RECORDS = `${BACKEND_BASE_URL}/api/subscription/user-subscription-records`;

// App users
export const LIST_USERS = `${BACKEND_BASE_URL}/api/user/list`;
export const DELETE_USER = `${BACKEND_BASE_URL}/api/user/delete-account`;
export const MANAGE_USER_SUBSCRIPTION = `${BACKEND_BASE_URL}/api/user/manage-subscription`;

// Running Text
export const GET_RUNNING_TEXT = `${BACKEND_BASE_URL}/api/running-text/`;
export const ADD_RUNNING_TEXT = `${BACKEND_BASE_URL}/api/running-text/`;

// App config
export const GET_FORCE_UPDATE_CONFIG = `${BACKEND_BASE_URL}/api/app-config/force-update`;
export const UPDATE_FORCE_UPDATE_CONFIG = `${BACKEND_BASE_URL}/api/app-config/force-update`;

// Blogs
export const ALL_BLOGS = `${BACKEND_BASE_URL}/api/blogs`;
export const GET_BLOG = (id) => `${BACKEND_BASE_URL}/api/blogs/${id}`;
export const CREATE_BLOG = `${BACKEND_BASE_URL}/api/blogs`;
export const UPDATE_BLOG = (id) => `${BACKEND_BASE_URL}/api/blogs/${id}`;
export const DELETE_BLOG = (id) => `${BACKEND_BASE_URL}/api/blogs/${id}`;
export const BLOG_CATEGORIES = `${BACKEND_BASE_URL}/api/blogs/categories`;
export const UPDATE_BLOG_CATEGORY = (id) =>
  `${BACKEND_BASE_URL}/api/blogs/categories/${id}`;
export const DELETE_BLOG_CATEGORY = (id) =>
  `${BACKEND_BASE_URL}/api/blogs/categories/${id}`;
export const PUBLISHED_BLOGS = `${BACKEND_BASE_URL}/api/blogs/published`;

// UPLOAD
export const UPLOAD_URL = `${BACKEND_BASE_URL}/api/upload`;
export const UPLOAD_BLOG_URL = `${BACKEND_BASE_URL}/api/upload/blog`;
